import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ITargetPayload,
  ITargetState,
  ITargetGetResponseOk,
  IFinderMessagePayload,
} from '../../types/@target';

const initialState: ITargetState = {
  isLoaded: false,
  isFinderMessageSending: false,
  isFinderMessageSent: false,
};

const targetSlice = createSlice({
  name: 'target',
  initialState,
  reducers: {
    getTarget: (state: ITargetState, { payload }: PayloadAction<ITargetPayload>) => {
      return {
        ...state,
        isLoaded: false,
      };
    },
    'getTarget/ok': (state: ITargetState, { payload }: PayloadAction<ITargetGetResponseOk>) => {
      return {
        ...state,
        isLoaded: true,
        info: payload,
      };
    },
    'getTarget/err': (state: ITargetState) => {
      return {
        ...state,
        isLoaded: true,
      };
    },

    sendFinderMessage: (state: ITargetState, { payload }: PayloadAction<IFinderMessagePayload>) => {
      return {
        ...state,
        isFinderMessageSending: true,
        isFinderMessageSent: false,
      };
    },
    'sendFinderMessage/ok': (state: ITargetState) => {
      return {
        ...state,
        isFinderMessageSending: false,
        isFinderMessageSent: true,
      };
    },
    'sendFinderMessage/err': (state: ITargetState) => {
      return {
        ...state,
        isFinderMessageSending: false,
      };
    },
    resetFinderMessageState: (state: ITargetState) => {
      return {
        ...state,
        isFinderMessageSending: false,
        isFinderMessageSent: false,
      };
    },
  },
});

export const targetActions = targetSlice.actions;
export const targetReducer = targetSlice.reducer;
